import React, { FC } from 'react';
import { useParams } from 'react-router-dom';
import { Box } from '@scope/scope-one-ui/core';
import { Loader } from 'ui';
import { ClimateChangeRisk } from '../ClimateChangeRisk';
import { TransitionRisk } from '../TransitionRisk';
import { PhysicalRisk } from '../PhysicalRisk';
import {
  useGetAvailability,
  useGetCountriesAndSectors,
  useGetEntity,
} from '../../services/climateStressTest';
import { ClimateStressTestParams, PageData } from '../../types/climateStressTest';
import { SummaryCardCST } from '../SummaryCardCST';

export const ClimateStressTest: FC = () => {
  const { entityId } = useParams<ClimateStressTestParams>();
  const { data: entity, loading: entityLoading, refetch } = useGetEntity(entityId!);
  const { data: isAvailable, loading: availabilityLoading } = useGetAvailability();
  const { data: countriesAndSectors, loading: casLoading } = useGetCountriesAndSectors();

  if (entityLoading || casLoading || availabilityLoading || !entity || !countriesAndSectors) {
    return <Loader center />;
  }

  if (!isAvailable) {
    return <SummaryCardCST onUnlocked={(unlocked) => unlocked && refetch()} />;
  }

  const pageData: PageData = {
    entity: {
      ...entity,
      isSovereign: entity.sector.code === 'AG',
    },
    countries: countriesAndSectors.countries,
    sectors: countriesAndSectors.sectors,
  };

  return (
    <Box display="flex" flexDirection="column" gridGap={4} mt={4}>
      <ClimateChangeRisk {...pageData} />
      <TransitionRisk {...pageData} />
      <PhysicalRisk {...pageData} />
    </Box>
  );
};
